(function () {
  'use strict';

  var ATTR_NAME = 'Date du mariage';
  var MONTHS = ['Janvier', 'Février', 'Mars', 'Avril', 'Mai', 'Juin', 'Juillet', 'Août', 'Septembre', 'Octobre', 'Novembre', 'Décembre'];
  var saving = false;
  var pendingCheckout = null;
  var attrController = null;
  var allowNativeCheckout = false;
  var rendering = false;

  function pad(n) {
    return String(n).padStart(2, '0');
  }

  function stripTime(d) {
    return new Date(d.getFullYear(), d.getMonth(), d.getDate());
  }

  function toIso(d) {
    return d.getFullYear() + '-' + pad(d.getMonth() + 1) + '-' + pad(d.getDate());
  }

  function isoToFr(iso) {
    var parts = String(iso || '').split('-');
    if (parts.length !== 3) return iso || '';
    return parts[2] + '/' + parts[1] + '/' + parts[0];
  }

  function toInputIso(value) {
    if (!value) return '';
    var raw = String(value).trim();
    if (/^\d{4}-\d{2}-\d{2}$/.test(raw)) return raw;
    var slash = raw.match(/^(\d{1,2})\/(\d{1,2})\/(\d{4})$/);
    if (slash) {
      return slash[3] + '-' + pad(slash[2]) + '-' + pad(slash[1]);
    }
    var parsed = new Date(raw);
    if (!isNaN(parsed.getTime())) return toIso(parsed);
    return '';
  }

  function isoToDate(iso) {
    var parsed = toInputIso(iso);
    if (!parsed) return null;
    var parts = parsed.split('-');
    return stripTime(new Date(parseInt(parts[0], 10), parseInt(parts[1], 10) - 1, parseInt(parts[2], 10)));
  }

  function sameDay(a, b) {
    return a && b && a.getFullYear() === b.getFullYear() && a.getMonth() === b.getMonth() && a.getDate() === b.getDate();
  }

  function mondayIndex(d) {
    return (d.getDay() + 6) % 7;
  }

  function lastDateOfMonth(y, m0) {
    return new Date(y, m0 + 1, 0).getDate();
  }

  function allRoots() {
    return document.querySelectorAll('[data-cart-wedding-date]');
  }

  function allInputs() {
    return document.querySelectorAll('[data-wedding-date-input]');
  }

  function currentIso() {
    var found = '';
    allInputs().forEach(function (input) {
      if (input.value) found = input.value;
    });
    return found;
  }

  function isValid(iso) {
    return !!toInputIso(iso);
  }

  function errorEl(root) {
    return root ? root.querySelector('[data-wedding-date-error]') : null;
  }

  function setCalendarOpen(root, open) {
    var cal = root.querySelector('[data-wedding-calendar]');
    var toggle = root.querySelector('[data-wedding-date-toggle]');
    if (!cal) return;
    if (root.hasAttribute('data-calendar-inline')) open = true;
    if (open) {
      allRoots().forEach(function (other) {
        if (other !== root) setCalendarOpen(other, false);
      });
    }
    cal.hidden = !open;
    if (toggle) toggle.setAttribute('aria-expanded', open ? 'true' : 'false');
  }

  function isShown(root) {
    return !!(root && (root.offsetWidth || root.offsetHeight || root.getClientRects().length));
  }

  function updateDateLabels(iso) {
    var text = iso ? isoToFr(iso) : 'Choisir une date';
    rendering = true;
    document.querySelectorAll('[data-wedding-date-label]').forEach(function (el) {
      if (el.textContent !== text) el.textContent = text;
      el.classList.toggle('is-placeholder', !iso);
    });
    rendering = false;
  }

  function showError(message) {
    var focused = false;
    allRoots().forEach(function (root) {
      var err = errorEl(root);
      if (!err) return;
      err.hidden = !message;
      err.textContent = message || '';
      if (message && isShown(root)) {
        setCalendarOpen(root, true);
        if (!focused) {
          focused = true;
          try { root.querySelector('[data-wedding-date-toggle]').focus(); } catch (e) {}
        }
      }
    });
  }

  function hideError() {
    showError('');
  }

  function cartLooksEmpty(btn) {
    var drawer = btn.closest('.cart__dropdown-bottom');
    if (drawer && drawer.classList.contains('is-empty')) return true;
    var page = btn.closest('.cart-template-footer__layout');
    if (page && page.classList.contains('is-empty')) return true;
    return false;
  }

  function phonesOk() {
    var hasFields = document.querySelector('[data-cart-order-phone]');
    if (!hasFields) return true;
    if (!window.FlorEasyCartPhones || typeof window.FlorEasyCartPhones.isValid !== 'function') return false;
    return window.FlorEasyCartPhones.isValid();
  }

  function phoneAttributes() {
    if (!window.FlorEasyCartPhones || typeof window.FlorEasyCartPhones.attributes !== 'function') return {};
    return window.FlorEasyCartPhones.attributes();
  }

  function syncCheckoutButtons() {
    document.querySelectorAll('button[name="checkout"], input[name="checkout"], [data-open-checkout-modal]').forEach(function (btn) {
      if (btn.closest('#checkout-contact-modal')) return;
      var minBlocked = btn.classList.contains('cart__checkout-button--blocked');
      var disable = minBlocked || cartLooksEmpty(btn);
      btn.disabled = disable;
      if (disable) btn.setAttribute('aria-disabled', 'true');
      else btn.removeAttribute('aria-disabled');
    });
  }

  function setAllValues(iso) {
    allInputs().forEach(function (input) {
      input.value = iso || '';
      if (iso) input.setAttribute('data-stored-date', isoToFr(iso));
    });
  }

  function renderCalendar(root) {
    var grid = root.querySelector('[data-wedding-cal-grid]');
    var monthLabel = root.querySelector('[data-wedding-cal-month]');
    if (!grid || !monthLabel || !root._weddingView) return;

    var view = root._weddingView;
    var selected = root._weddingSelected;
    monthLabel.textContent = MONTHS[view.getMonth()] + ' ' + view.getFullYear();
    grid.innerHTML = '';

    var y = view.getFullYear();
    var m = view.getMonth();
    var startPad = mondayIndex(new Date(y, m, 1));
    var daysInMonth = lastDateOfMonth(y, m);

    for (var i = 0; i < 42; i++) {
      var dayOffset = i - startPad + 1;
      var cellDate = new Date(y, m, dayOffset);
      var dOnly = stripTime(cellDate);
      var isMuted = dayOffset < 1 || dayOffset > daysInMonth;
      var cell = document.createElement('button');
      cell.type = 'button';
      cell.className = 'cart-wedding-date__day';
      if (isMuted) cell.classList.add('is-muted');
      if (selected && sameDay(dOnly, selected)) cell.classList.add('is-selected');
      cell.textContent = String(cellDate.getDate());
      cell.setAttribute('data-iso', toIso(dOnly));
      cell.addEventListener('click', function () {
        pickDate(this.getAttribute('data-iso'));
      });
      grid.appendChild(cell);
    }
  }

  function pickDate(iso) {
    if (!iso) return;
    setAllValues(iso);
    allRoots().forEach(function (root) {
      root._weddingSelected = isoToDate(iso);
      if (root._weddingSelected) {
        root._weddingView = new Date(root._weddingSelected.getFullYear(), root._weddingSelected.getMonth(), 1);
      }
      renderCalendar(root);
    });
    updateDateLabels(iso);
    allRoots().forEach(function (root) { setCalendarOpen(root, false); });
    hideError();
    saveAttribute(iso);
    syncCheckoutButtons(true);
  }

  function initCalendar(root) {
    if (root.dataset.calendarReady === '1') return;
    root.dataset.calendarReady = '1';

    var input = root.querySelector('[data-wedding-date-input]');
    var stored = toInputIso((input && (input.value || input.getAttribute('data-stored-date'))) || currentIso());
    if (stored && input) input.value = stored;

    var selected = stored ? isoToDate(stored) : null;
    var today = stripTime(new Date());
    root._weddingSelected = selected;
    root._weddingView = selected
      ? new Date(selected.getFullYear(), selected.getMonth(), 1)
      : new Date(today.getFullYear(), today.getMonth(), 1);

    var prevBtn = root.querySelector('[data-wedding-cal-prev]');
    var nextBtn = root.querySelector('[data-wedding-cal-next]');
    if (prevBtn) {
      prevBtn.addEventListener('click', function (event) {
        event.preventDefault();
        root._weddingView = new Date(root._weddingView.getFullYear(), root._weddingView.getMonth() - 1, 1);
        renderCalendar(root);
      });
    }
    if (nextBtn) {
      nextBtn.addEventListener('click', function (event) {
        event.preventDefault();
        root._weddingView = new Date(root._weddingView.getFullYear(), root._weddingView.getMonth() + 1, 1);
        renderCalendar(root);
      });
    }

    renderCalendar(root);
  }

  function initCalendars() {
    rendering = true;
    allRoots().forEach(initCalendar);
    rendering = false;
  }

  function refresh() {
    if (rendering) return;
    initCalendars();
    var iso = currentIso();
    if (!iso) {
      allInputs().forEach(function (input) {
        var stored = toInputIso(input.getAttribute('data-stored-date') || '');
        if (stored && !input.value) input.value = stored;
      });
      iso = currentIso();
    }
    updateDateLabels(iso);
    syncCheckoutButtons(isValid(iso));
    if (isValid(iso)) hideError();
  }

  function cartUpdateUrl() {
    return (window.routes && window.routes.cart_update_url) || '/cart/update.js';
  }

  function saveAttribute(iso, callback) {
    if (window.FlorEasyCartPhones && typeof window.FlorEasyCartPhones.cancelPending === 'function') {
      window.FlorEasyCartPhones.cancelPending();
    }
    var attrs = phoneAttributes();
    attrs[ATTR_NAME] = isoToFr(iso);
    if (attrController) attrController.abort();
    attrController = typeof AbortController === 'function' ? new AbortController() : null;
    var controller = attrController;
    saving = true;
    fetch(cartUpdateUrl(), {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        Accept: 'application/javascript'
      },
      body: JSON.stringify({ attributes: attrs }),
      signal: controller ? controller.signal : undefined
    })
      .then(function (res) {
        if (!res.ok) throw new Error('cart update failed');
        return res.json();
      })
      .then(function (cart) {
        if (controller !== attrController) return;
        var saved = cart && cart.attributes ? cart.attributes : {};
        var missing = attrs[ATTR_NAME] && saved[ATTR_NAME] !== attrs[ATTR_NAME];
        if (missing) throw new Error('attribute missing');
        allInputs().forEach(function (input) {
          input.setAttribute('data-stored-date', isoToFr(iso));
        });
        if (typeof callback === 'function') callback(true);
      })
      .catch(function (error) {
        if (error && error.name === 'AbortError') return;
        if (typeof callback === 'function') callback(false);
      })
      .finally(function () {
        saving = false;
      });
  }

  function submitCheckout(btn) {
    var form = btn.form || btn.closest('form');
    if (!form) return;
    if (typeof form.requestSubmit === 'function') {
      btn.disabled = false;
      form.requestSubmit(btn);
      return;
    }
    var hidden = form.querySelector('input[data-wedding-checkout-flag]');
    if (!hidden) {
      hidden = document.createElement('input');
      hidden.type = 'hidden';
      hidden.name = 'checkout';
      hidden.setAttribute('data-wedding-checkout-flag', '1');
      form.appendChild(hidden);
    }
    form.submit();
  }

  document.addEventListener('click', function (event) {
    var toggle = event.target.closest('[data-wedding-date-toggle]');
    if (!toggle) return;
    event.preventDefault();
    var root = toggle.closest('[data-cart-wedding-date]');
    var cal = root && root.querySelector('[data-wedding-calendar]');
    if (!root || !cal) return;
    setCalendarOpen(root, cal.hidden);
  });

  document.addEventListener('click', function (event) {
    if (event.target.closest('[data-cart-wedding-date]')) return;
    allRoots().forEach(function (root) {
      if (root.hasAttribute('data-calendar-inline')) return;
      setCalendarOpen(root, false);
    });
  });

  document.addEventListener('click', function (event) {
    if (!event.target.closest('.additional-checkout-buttons')) return;
    event.preventDefault();
    event.stopPropagation();
    if (window.FlorEasyCheckoutModal) window.FlorEasyCheckoutModal.open();
  }, true);

  document.addEventListener('click', function (event) {
    if (allowNativeCheckout) return;
    var btn = event.target.closest('button[name="checkout"], input[name="checkout"], [data-open-checkout-modal]');
    if (!btn) return;
    if (btn.closest('#checkout-contact-modal')) return;
    if (btn.classList.contains('cart__checkout-button--blocked')) return;
    if (cartLooksEmpty(btn)) return;

    event.preventDefault();
    event.stopPropagation();
    if (window.FlorEasyCheckoutModal) window.FlorEasyCheckoutModal.open();
  }, true);

  function boot() {
    refresh();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
  window.addEventListener('load', boot);
  document.addEventListener('shopify:section:load', boot);

  var observed = [];
  function observeRoot(root) {
    if (!root || observed.indexOf(root) !== -1) return;
    observed.push(root);
    new MutationObserver(function () {
      if (rendering) return;
      refresh();
    }).observe(root, { childList: true, subtree: true });
  }
  observeRoot(document.getElementById('cart-dropdown-bottom'));
  observeRoot(document.getElementById('main-cart-footer'));

  window.FlorEasyWeddingDate = {
    refresh: refresh,
    isDateValid: function () { return isValid(currentIso()); },
    showDateError: showError,
    saveAndCheckout: function (callback) {
      var iso = currentIso();
      if (!isValid(iso)) {
        showError('Merci d’indiquer la date de votre mariage pour continuer.');
        if (typeof callback === 'function') callback(false);
        return;
      }
      saveAttribute(iso, callback);
    }
  };
})();
